import { render } from "./GenerateCard.vue?vue&type=template&id=510dd47f&scoped=true&ts=true"
import script from "./GenerateCard.vue?vue&type=script&lang=ts"
export * from "./GenerateCard.vue?vue&type=script&lang=ts"

import "./GenerateCard.vue?vue&type=style&index=0&id=510dd47f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510dd47f"]])

export default __exports__